"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createGroceryItemsAndLinksMutationOptions = exports.createGroceryItemsAndLinksMutation = void 0;
const client_1 = require("@apollo/client");
const groceryCategory_1 = require("../fragments/groceryCategory");
const groceryItem_1 = require("../fragments/groceryItem");
const groceryItems_1 = require("../queries/groceryItems");
exports.createGroceryItemsAndLinksMutation = client_1.gql `
  mutation CreateGroceryItemsAndLinks(
    $items: [GroceryItemStringInput!]!
    $recipeId: String
    $noName: Boolean
  ) {
    createGroceryItemsAndLinks(
      items: $items
      recipeId: $recipeId
      noName: $noName
    ) {
      __typename
      errors {
        path
        message
      }
      groceryItems {
        ...GroceryListItem
      }
    }
  }
  ${groceryItem_1.groceryRecipeInfoFragment}
  ${groceryItem_1.groceryListItemFragment}
  ${groceryCategory_1.groceryCategoryInfoFragment}
`;
exports.createGroceryItemsAndLinksMutationOptions = (variables) => ({
    variables,
    update: (store, { data: responseData }) => {
        if (responseData) {
            const { createGroceryItemsAndLinks: { groceryItems }, } = responseData;
            let data;
            try {
                data = store.readQuery({
                    query: groceryItems_1.groceryItemsQuery,
                });
            }
            catch (err) {
                return;
            }
            if (data && groceryItems) {
                store.writeQuery({
                    query: groceryItems_1.groceryItemsQuery,
                    data: {
                        __typename: "Query",
                        groceryItems: {
                            __typename: "GroceryItemsResponse",
                            items: [...groceryItems, ...data.groceryItems.items],
                            recipes: data.groceryItems.recipes,
                        },
                    },
                });
            }
        }
    },
});
//# sourceMappingURL=CreateGroceryItems.js.map